export default __webpack_public_path__ + "static/media/logo.4fe9c1e8.svg";